import request from '@/utils/request'

// export function login (data) {
//   return request.post('/api/login', data)
// }

/**
 * 专家注册接口
 */
export function expertRegister(data) {
  return request({
    url: '/basic/Login/ExpertRegister',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 登录发送验证码
export function getLoginSmsCode (data) {
  return request({
    url: '/web/Sms/LoginSmsCode',
    method: 'get',
    params: data
  })
}

// 注册发送验证码
export function getRegisterSmsCode (data) {
  return request({
    url: '/web/Sms/RegSmsCode',
    method: 'get',
    params: data
  })
}

// 找回密码发送验证码
export function getFindPasswordSmsCode (data) {
  return request({
    url: '/web/Sms/FindPasswordSmsCode',
    method: 'get',
    params: data
  })
}


// 供应商注册
export function supplierRegister(data) {
  return request({
    url: '/basic/Login/SupplierRegister',
    method: 'post',
    data
  });
}

// 密码用户登录
export function userLogin(data) {
  return request({
    url: '/basic/Login/UserLogin',
    method: 'post',
    data
  });
}
// 短信验证码用户登录
export function smsLogin(data) {
  return request({
    url: '/basic/Login/SmsLogin',
    method: 'post',
    data
  });
}
// 供应商/专家 找回密码
export function findPassword(data) {
  return request({
    url: '/basic/Login/FindPassword',
    method: 'post',
    data
  });
}

